import React, {useCallback, useState} from 'react';
import {Autocomplete, ListBoxOptionType} from '@flixbus/honeycomb-react';
import {CalculationAutocompleteFilterProps} from './CalculationAutocompleteFilter.types';

const CalculationAutocompleteFilter: React.FC<
  CalculationAutocompleteFilterProps
> = ({label, options, handleSelect}) => {
  const [filteredOptions, setFilteredOptions] = useState<any>([]);

  const handleDebounce = useCallback(
    async (inputValue: string) => {
      const searchedText = inputValue.toLowerCase();

      if (!searchedText) {
        setFilteredOptions([]);
        return [];
      }

      const filteredOptions = options.filter(option =>
        option.title.toLowerCase().startsWith(searchedText)
      );
      setFilteredOptions(filteredOptions);

      return filteredOptions;
    },
    [options]
  );

  const onSelect = useCallback(
    (selectedOptions: ListBoxOptionType[]) => {
      handleSelect(selectedOptions);
    },
    [handleSelect]
  );

  const renderOption = useCallback(
    (option: ListBoxOptionType) => option.title,
    []
  );

  return (
    <Autocomplete
      comboboxProps={{
        label,
        resetProps: {
          label: 'Reset',
          onClick: () => onSelect([])
        }
      }}
      options={filteredOptions}
      listBoxProps={{
        optionsToDisplay: 5,
        optionProps: (option: ListBoxOptionType) => ({
          renderOption: () => renderOption(option)
        })
      }}
      onDebounce={handleDebounce}
      onChange={onSelect}
      multiple
    />
  );
};

export default React.memo(CalculationAutocompleteFilter);
